// src/pages/spot/components/LoadingModal.js
// 로딩 팝업 컴포넌트 (확인 버튼 없이)

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ModalOverlay } from '../styles/SpotStyles';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingModal = ({ isOpen, message }) => {
  const { t } = useTranslation();
  const resolvedMessage = message || t('spot_loading');
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <LoadingContent>
        <Spinner />
        <LoadingText>{resolvedMessage}</LoadingText>
      </LoadingContent>
    </ModalOverlay>
  );
};

const LoadingContent = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  min-width: 200px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(108, 92, 231, 0.2);
  border-top-color: #6C5CE7;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.div`
  font-size: 0.95rem;
  font-weight: 600;
  color: #1F2937;
  font-family: 'Noto Sans KR', sans-serif;
`;

export default LoadingModal;
